import { ApiError, ApiErrorCategory, ApiErrorType } from "../api/error";

export const AuthInvalidCredentialsError = new ApiError(
  ApiErrorCategory.CLIENT_ERROR,
  ApiErrorType.AUTH_INVALID_CREDENTIALS,
  "Email or password is incorrect.",
);

export const AuthUserExistsError = new ApiError(
  ApiErrorCategory.CLIENT_ERROR,
  ApiErrorType.AUTH_USERNAME_EXISTS,
  "Username already exists.",
);

export const AuthUsernameDoesNotExistError = new ApiError(
  ApiErrorCategory.CLIENT_ERROR,
  ApiErrorType.AUTH_USERNAME_DOES_NOT_EXIST,
  "Username does not exist.",
);

export const AuthRateLimitExceededError = new ApiError(
  ApiErrorCategory.CLIENT_ERROR,
  ApiErrorType.AUTH_RATE_LIMIT_EXCEEDED,
  "Rate limit exceeded. Please try again later.",
);

export const AuthCodeExpiredError = new ApiError(
  ApiErrorCategory.CLIENT_ERROR,
  ApiErrorType.AUTH_CODE_EXPIRED,
  "Confirmation code has expired.",
);

export const AuthCodeMismatchedError = new ApiError(
  ApiErrorCategory.CLIENT_ERROR,
  ApiErrorType.AUTH_CODE_MISMATCH,
  "The verification code is incorrect.",
);

export const AuthUserNotConfirmedError = new ApiError(
  ApiErrorCategory.CLIENT_ERROR,
  ApiErrorType.AUTH_USER_NOT_CONFIRMED,
  "Email address is not confirmed.",
);
